<div class="version-display">
    <img src="assets/logoMaibec bleu 1.png" alt="Maibec Logo" class="logo" />
    © Maibec version - {{ version }} - {{ date }}
</div>
